// app backgound 3451d7

export default function AppBackground({ children }) {
    return (
        <div
            style={{
                backgroundColor: "#3451d7",
                // height: "100vh",
                // width: "100vw",
                overflow: "auto",
                position: "relative",
            }}
        >
            {children}
        </div>
    );
}